import React, {Component} from "react";
import {connect} from "react-redux";
import BaseDateField from '../../../Base/ui/inputs/DateField'
import updateAssociationName from "../helpers/update_association_name";

class DateField extends Component {
  handleChange(resource, date) {
    this.props.handleChange(this.props.name, date ? date.format("YYYY-MM-DD") : null, resource);
  }

  render() {
    const {resource, name, label, col, action, value} = this.props;
    return (
      <BaseDateField
        resource={resource}
        name={name}
        label={label}
        col={col}
        value={value}
        action={action}
        onChange={this.handleChange.bind(this, resource)}/>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {resource = "affiliateMemberDetail", name} = ownProps;

  return {
    resource: resource,
    value: state[resource] === null ? '' : state[resource][name],
    action: ownProps.action || state.ui.action
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleChange: (name, value, resource) => dispatch({type: `UPDATE_${updateAssociationName(resource)}`, payload: {name, value}})
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DateField);
